// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f958f4ff","453":"145d09a2"}[chunkId] + ".chunk.js";
};